import { i18n } from '@/plugins/i18n'
import { primevueLocales, setPrimeVueLocale } from '@/plugins/primevue'

const DEFAULT_LOCALE = 'de'

type SupportedLocale = keyof typeof primevueLocales

const normalizeLocale = (locale?: string): SupportedLocale => {
  return locale && locale in primevueLocales ? (locale as SupportedLocale) : DEFAULT_LOCALE
}

const setI18nLocale = (locale: SupportedLocale) => {
  getI18nLocaleRef().value = locale
}

export function getFrontendLocale(): string {
  return getI18nLocaleRef().value
}

export function setFrontendLocale(locale?: string) {
  const normalizedLocale = normalizeLocale(locale)

  setI18nLocale(normalizedLocale)
  setPrimeVueLocale(normalizedLocale)

  return normalizedLocale
}

function getI18nLocaleRef() {
  return i18n.global.locale as unknown as { value: string }
}
